import script from "./CitizenBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./CitizenBadge.vue?vue&type=script&lang=ts&setup=true"

import "./CitizenBadge.vue?vue&type=style&index=0&id=2a2675b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2675b6"]])

export default __exports__